import {Switch} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {Observer, SubNavBarButton, SubNavBar} from "web-vcore";
import {store} from "../../Store/index.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

export const FeedbackUI = observer_mgl(()=>{
	const currentSubpage = store.main.more.feedback.subpage;
	const page = "feedback";
	return <ProposalsUI/>;
});

export const ProposalsUI = (()=>{
	/*const ProposalsUI_Base2 = ProposalsUI_Base as any; // temp fix
	return (
		<ProposalsUI_Base2 subNavBarWidth={84}/>
	);*/
	return <div>To be added. (for now, ask admin for access to issue-tracker)</div>;
});